import styled, { keyframes } from "styled-components";

import { PrimaryButton } from "components/Button";

interface ISectionProps {
  title?: string;
  type?: string;
  size?: string;
}

export const ModalContainer = styled.div`
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalBackdrop = styled.div`
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: 0;
  background-color: ${({ theme }) => theme.customTheme.palette.semiTransparentBackground.standard};
`;

export const StyledContainer = styled.section<ISectionProps>`
  border-radius: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  z-index: 1;
  position: absolute;
  width: 340px;
  min-height: 348px;
  max-height: ${({ size }) => (size === "small" ? "348px" : "708px")};
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  display: flex;
  flex-direction: column;
  align-items: ${({ type }) => (type === "logout" ? "center" : "flex-start")};
  justify-content: center;
  padding: 36px 30px;
  gap: 16px;
  box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.15);

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: ${({ type }) => (type === "error" || type === "cancelation" || type === "cookies" ? "448px" : "682px")};
    padding: 48px 72px;
  }
`;

export const ErrorStyledContainer = styled(StyledContainer)`
  width: 327px;
  height: ${({ size }) => (size === "small" ? "396px" : "456px")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  gap: 24px;
`;

export const StyledCookieContainer = styled(StyledContainer)`
  width: 327px;
  min-height: 348px;
  max-height: ${({ size }) => (size === "small" ? "348px" : "708px")};
  display: flex;
  flex-direction: column;
  align-items: ${({ type }) => (type === "logout" ? "center" : "flex-start")};
  padding: 68px 30px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 377px;
    padding: 68px 30px;
  }
`;

export const CrossBtn = styled.button`
  position: absolute;
  display: flex;
  top: ${({ theme }) => theme.customTheme.pxToRem(10)};
  right: ${({ theme }) => theme.customTheme.pxToRem(10)};
  width: ${({ theme }) => theme.customTheme.pxToRem(32)};
  height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  border: none;
  cursor: pointer;
  border-radius: 200px;
  background: rgba(139, 147, 156, 0.1);
  padding: 6px;
  justify-content: center;
  align-items: center;
`;

export const StyledBigIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding-top: 16px;
  }
`;
interface ITextAlignProps {
  $textAlign?: string | null;
}

interface IChildrenWrapperProps {
  $textAlign?: string | null;
  $enableGradient: boolean;
}

export const StyledTitle = styled.h2<ITextAlignProps>`
  width: 100%;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  margin: 0px auto;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
  line-height: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  overflow-wrap: break-word !important;
`;

export const StyledDescription = styled.p<ITextAlignProps>`
  width: 100%;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  margin: 0px auto;
  word-wrap: break-word;
`;

export const ChildrenWrapper = styled.div<IChildrenWrapperProps>`
  width: 100%;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  overflow-y: auto;

  * {
    color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};
  }

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  max-height: 200px;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ${({ $enableGradient }) =>
    $enableGradient &&
    `
    :after {
      content: "";
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: 0px;
      height: 30%;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
      pointer-events: none;
      border-radius: 0px 0px 12px 12px;
    }
  `}
`;

export const ButtonContainer = styled.div`
  padding-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const DoneButton = styled(PrimaryButton)`
  width: 105px;
  background-color: ${({ theme }) => theme.customTheme.palette.black.black25};
`;

export const StyledHeader = styled.section`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    justify-content: center;
  }
`;

export const StyledCookieTitle = styled.h2`
  font-family: ThemeFontBold;
  font-size: 18px;
  margin: 0px auto;
  margin-bottom: 16px;
  text-align: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: 24px;
  }
`;

export const StyledCookieDescription = styled.p`
  line-height: 24px;
  margin-bottom: 40px;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  overflow: auto;

  a {
    color: ${({ theme }) => theme.customTheme.palette.black.black25};
  }
`;

export const StyledButtonsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: center;
  }
`;

export const StyledCookieButtonsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const CookiesBtn = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  width: 100%;
  background-color: ${({ theme }) => theme.customTheme.palette.black.black25};
`;

export const StyledIcon = styled.i`
  display: flex;
`;

const slideUpFromBottom = keyframes`
  from {
    transform: translateY(100vh);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const LoginOptionsPanel = styled.section`
  position: relative;
  width: 100%;
  min-width: 480px;
  width: 480px;
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  border-radius: 24px;
  box-shadow: 0 0 0 1px #fff, 0 12px 20px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 24px;
  animation: ${slideUpFromBottom} 0.3s ease-out;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 560px;
    padding: 48px 40px;
  }
  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    position: fixed;
    bottom: 0;
    width: 100%;
    min-width: 0;
    border-radius: 24px 24px 0 0;
    padding: 48px 20px;
  }
`;

export const OptinPanel = styled(LoginOptionsPanel)`
  gap: 0;
`;

interface ILoginOptionsHeaderProps {
  variant?: string;
}

export const LoginOptionsHeader = styled.h2<ILoginOptionsHeaderProps>`
  margin: 0;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(29)};
  line-height: 20px;
  font-weight: 700;
  color: #101112;
  font-style: normal;
  line-height: 36.3px;
  letter-spacing: 0;
  text-align: ${({ variant }) => (variant === "centerHeader" ? "center" : "left")};

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: 26px;
    line-height: 36.3px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: 24px;
    font-style: normal;
    line-height: 30px;
    letter-spacing: 0px;
  }
`;

export const LoginOptionsBody = styled.div`
  width: 100%;
`;

export const LoginOptionsSectionTitle = styled.h3`
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(19)};

  color: #101112;
  font-style: normal;
  font-weight: 700;
  line-height: 26.6px;
  letter-spacing: 0.43px;

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: 17px;
    line-height: 23.8px;
    letter-spacing: 0.352px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.31px;
  }
`;

export const LoginOptionsSectionDescription = styled.p<ILoginOptionsHeaderProps>`
  text-align: ${({ variant }) => (variant === "centerDesciption" ? "center" : "left")};
  margin: 0;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(19)};
  line-height: 26.6px;
  font-weight: 400;
  color: var(--text-secondary, #56606b);
  font-style: normal;
  letter-spacing: 0.43px;

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: 17px;
    line-height: 23.8px;
    letter-spacing: 0.352px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.31px;
  }
`;

export const OptinPriceSection = styled.div`
  width: 100%;
  padding: 16px;
`;

export const OptinPriceCard = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.customTheme.palette.white.whiteF3};
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
`;

export const OptinPriceSubSection = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const OptinPriceLabel = styled.span`
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
`;

export const OptinPriceValue = styled.span`
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  color: #101112;
`;

export const LoginOptionsDivider = styled.hr`
  margin: 16px 0;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.customTheme.palette.grey.greyDCE};
`;

export const LoginOptionsButtonsArea = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    margin-top: 24px;
  }
`;

// pill-shaped primary and secondary buttons
export const LoginOptionsPrimaryButton = styled(PrimaryButton)`
  width: 100%;
  border-radius: 100px;
  height: 48px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-shadow: 0 4px 20px 0 rgba(230, 0, 0, 0.4);

  color: #fff;
  text-align: center;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(19)};
  font-style: normal;
  font-weight: 700;
  line-height: 26.6px;
  letter-spacing: 0.43px;

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: 17px;
    line-height: 23.8px;
    letter-spacing: 0.352px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.31px;
  }
`;

export const LoginOptionsSecondaryButton = styled(PrimaryButton)`
  width: 100%;
  border-radius: 100px;
  background: ${({ theme }) => theme.customTheme.palette.white.standard};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  border: 2px solid ${({ theme }) => theme.customTheme.palette.black.black25};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(19)};
  display: flex;
  height: 48px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  font-family: ThemeFontBold;

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: 17px;
    line-height: 23.8px;
    letter-spacing: 0.352px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.31px;
  }
`;

export const DeclinedConfirmationButtonsArea = styled(LoginOptionsButtonsArea)`
  width: 100%;
`;
